export const updateCategoryResults = (resultField: string) => (
  state: any,
  action: any
) => ({
  ...state,
  inspection: {
    ...state.inspection,
    inspectionCategoryResults: action.payload.data?.[resultField],
  },
});
